import { IMainScope } from '../../app/IMainScope';
import { editSelfServiceSchedule } from '../../app/sagas/spaces/ScheduleMenuSagas';
import { FeatureFlags } from '../FeatureFlags';
import { ActionContext } from '../helpers/ActionContext';
import { Module } from '../Module';
import { ISchedule, ScheduleActions } from '../ServerApi/types/ISchedule';
import { CreateScheduleAction } from '../services/CreateScheduleAction';
import { SchedulePermissions } from '../services/SchedulePermissions';
import { SetScheduleStatusAction } from '../services/SetScheduleStatusAction';
import { ToasterService } from '../services/ToasterService';
import { IScheduleViewModel } from './CreateOrEditScheduleCtrl';
import { CreateOrEditScheduleViewModelMapper } from './CreateOrEditScheduleViewModelMapper';
import { DeleteContentsAction } from '../services/DeleteContentsAction';
import { IContentInfo } from '../models/IContentInfo';
import { IScheduleInfo } from '../models/IScheduleInfo';

export interface ISchedulePlaceScope extends IMainScope {
  // comes from parent scope (angular directive in ScheduleSpace)
  schedule: ISchedule;
  scheduleDescription: string;
  navigateToAllSchedules: () => void;
  reloadSpace: () => void;

  scheduleViewModel: IScheduleViewModel;
  scheduleStatus: { enabled: boolean };
  scheduledActionType: string;

  editMode: boolean;
  busy: boolean;
  beginEdit: ($event: JQueryEventObject) => void;
  cancelEdit: ($event: JQueryEventObject) => void;
  save: ($event: JQueryEventObject) => void;

  del: ($event: JQueryEventObject) => void;

  // Permissions
  canEditSchedule: () => boolean;
}

export class ScheduleSpaceDetailsCtrl {

  public static $inject = [
    '$scope',
    'SchedulePermissions',
    'CreateScheduleAction',
    'DeleteContentsAction',
    'SetScheduleStatusAction'
  ];

  constructor(
            $scope: ISchedulePlaceScope,
            SchedulePermissions: SchedulePermissions,
    private CreateScheduleAction: CreateScheduleAction,
    private DeleteContentsAction: DeleteContentsAction,
    private SetScheduleStatusAction: SetScheduleStatusAction
  ) {
    const schedule = $scope.schedule;

    $scope.canEditSchedule = () => IScheduleInfo.isEditable(schedule) && SchedulePermissions.canEditSchedule();

    $scope.scheduledActionType = schedule.scheduledAction;

    // Edit schedule
    $scope.beginEdit = () => {
      if (FeatureFlags.adminSelfServiceSchedulesEnabled) {
        editSelfServiceSchedule($scope.schedule as any).then(() => {
          $scope.reloadSpace();
        });
      } else {
        $scope.scheduleViewModel = CreateOrEditScheduleViewModelMapper.viewModelFromSchedule($scope.schedule);
        $scope.editMode = true;
      }
    };
    $scope.cancelEdit = () => $scope.editMode = false;
    $scope.save = ($event: JQueryEventObject) => {
      $scope.busy = true;
      this.CreateScheduleAction.submitScheduleUpdate($scope.scheduleViewModel, $scope.schedule.name)
        .then(() => {
          $scope.editMode = false;
          $scope.reloadSpace();
        })
        .finally(() => $scope.busy = false);
    };

    $scope.scheduleStatus = {
      enabled: !!schedule.runNextAt
    };
    $scope.$watch('scheduleStatus.enabled', (newVal: boolean, oldVal: boolean) => {
      if (newVal !== oldVal) {
        const action = newVal
          ? this.SetScheduleStatusAction.enableSchedule(schedule)
          : this.SetScheduleStatusAction.disableSchedule(schedule);
        action.then(() => $scope.reloadSpace());
      }
    });

    const scheduleInfo = {...schedule, contentType: 'schedule'} as unknown as IContentInfo;

    $scope.del = ($event: JQueryEventObject) => {
      this.DeleteContentsAction.confirmDeleteContents([scheduleInfo], ActionContext.fromEvent($event))
        .then(() => {
          ToasterService.instance.markToastsAsDoNotDismissOnLocationChange();
          $scope.navigateToAllSchedules();
        });
    };
  }
}

Module.instance().controller('ScheduleSpaceDetailsCtrl', ScheduleSpaceDetailsCtrl);
